/* eslint-disable max-lines-per-function */
import React, { FC } from 'react'

export interface FlowerProps {
  className?: string
}
export const Flower: FC<FlowerProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill={'none'}
      height={'100%'}
      viewBox={'0 0 40 73'}
      width={'100%'}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <g clipPath={'url(#clip0_10731_6141)'} id={'Executions_02'}>
        <g id={'Group'}>
          <g id={'Group_2'}>
            <path
              clipRule={'evenodd'}
              d={
                'M19.8807 16.0735L21.8741 17.2258L25.3178 7.51061L19.8807 0.749023L14.4436 7.51061L17.8939 17.2258L19.8807 16.0735Z'
              }
              fill={'#ED6A70'}
              fillRule={'evenodd'}
              id={'Vector'}
            />
            <path
              d={
                'M19.8807 15.4371C20.6489 15.7351 21.4834 16.0993 22.2847 16.5099L21.0926 16.947C22.0728 13.649 23.2913 10.4371 24.4966 7.21854L24.6357 8.05298C23.3244 6.33113 20.6423 2.90066 19.2913 1.21854H20.4569L17.7748 4.62914L15.139 8.07285L15.2847 7.2053C16.49 10.4238 17.7681 13.6159 18.7218 16.9205L17.4304 16.4437C18.2516 16.0331 19.0993 15.6821 19.8675 15.4305L19.8807 15.4371ZM19.8807 16.7152C19.0728 17.3245 18.0794 18.8212 17.1787 17.7947C16.3907 16.1523 15.8476 14.4106 15.2317 12.702C14.6688 11.0795 14.1324 9.44371 13.596 7.81457C13.4834 7.50993 13.5496 7.17881 13.7417 6.94702L16.543 3.62914L19.2979 0.278146C19.5893 -0.0927152 20.1721 -0.0927152 20.4635 0.278146C21.8211 1.96689 24.5893 5.31788 25.9933 6.96689C26.192 7.2053 26.2383 7.52318 26.1324 7.80132C25.033 11.0927 23.9403 14.3841 22.6092 17.596C21.8741 18.8675 20.6688 17.2517 19.8807 16.7152Z'
              }
              fill={'#181716'}
              id={'Vector_2'}
            />
          </g>
          <g id={'Group_3'}>
            <path
              clipRule={'evenodd'}
              d={
                'M19.8808 29.6027L17.8941 28.457L14.4437 38.1723L19.8808 44.9338L25.3179 38.1723L21.8742 28.457L19.8808 29.6027Z'
              }
              fill={'#ED6A70'}
              fillRule={'evenodd'}
              id={'Vector_3'}
            />
            <path
              d={
                'M19.8808 30.2455C19.1126 29.9475 18.2781 29.5832 17.4768 29.1726L18.6689 28.7356C17.6887 32.0336 16.4702 35.2455 15.2649 38.464L15.1258 37.6296C16.4371 39.3514 19.1192 42.7819 20.4702 44.464H19.3046L21.9868 41.0534L24.6225 37.6097L24.4768 38.4773C23.2715 35.2587 21.9934 32.0667 21.0397 28.762L22.3311 29.2389C21.5099 29.6495 20.6622 30.0005 19.894 30.2521L19.8808 30.2455ZM19.8808 28.9673C20.6887 28.3581 21.6821 26.8614 22.5828 27.8879C23.3709 29.5303 23.9139 31.272 24.5298 32.9806C25.0927 34.6031 25.6291 36.2389 26.1656 37.868C26.2781 38.1726 26.2119 38.5038 26.0199 38.7356L23.2185 42.0534L20.4636 45.4044C20.1722 45.7753 19.5894 45.7753 19.298 45.4044C17.9404 43.7157 15.1722 40.3647 13.7682 38.7157C13.5695 38.4773 13.5232 38.1594 13.6291 37.8813C14.7285 34.5899 15.8212 31.2985 17.1523 28.0865C17.8874 26.815 19.0927 28.4309 19.8808 28.9673Z'
              }
              fill={'#181716'}
              id={'Vector_4'}
            />
          </g>
          <g id={'Group_4'}>
            <path
              clipRule={'evenodd'}
              d={
                'M30.4439 10.4639L23.7485 18.3049L25.7419 19.4572V21.7553L35.881 19.8811L39.0134 11.795L30.4439 10.4639Z'
              }
              fill={'#ED6A70'}
              fillRule={'evenodd'}
              id={'Vector_5'}
            />
            <path
              d={
                'M30.6624 11.0666C28.722 13.9209 26.6624 16.3448 24.4439 18.9011L24.2054 17.5236L26.1723 18.709L26.1988 18.7289C26.4637 18.8878 26.6094 19.1726 26.6028 19.464L26.5564 21.762L25.5895 20.954C28.9869 20.411 32.3644 19.7819 35.7286 19.1064L35.1326 19.5964C36.126 16.8812 37.0929 14.1527 38.0995 11.4375L38.8611 12.7554C36.073 12.3514 33.3644 11.9209 30.6558 11.06L30.6624 11.0666ZM30.2187 9.86795C33.1922 9.84146 36.2187 10.358 39.1657 10.8282C39.7816 10.9077 40.1657 11.5766 39.9273 12.1527C38.8412 14.8348 37.7154 17.5037 36.616 20.1726C36.5167 20.4375 36.2783 20.6163 36.02 20.6627C32.6293 21.2388 29.2518 21.8547 25.8876 22.5633C25.3909 22.6759 24.9008 22.2653 24.9207 21.7554L24.8743 19.4574L25.3048 20.2057L23.2915 19.0931C22.8611 18.8547 22.7021 18.3117 22.9405 17.8746C25.1922 15.1196 27.6558 12.2719 30.2187 9.86133V9.86795Z'
              }
              fill={'#181716'}
              id={'Vector_6'}
            />
          </g>
          <g id={'Group_5'}>
            <path
              clipRule={'evenodd'}
              d={
                'M14.0264 19.4563L16.0132 18.3039L9.32445 10.4629L0.748291 11.794L3.88736 19.8801L14.0264 21.7543V19.4563Z'
              }
              fill={'#ED6A70'}
              fillRule={'evenodd'}
              id={'Vector_7'}
            />
            <path
              d={
                'M13.4702 19.1385C14.1125 18.6219 14.841 18.0855 15.6026 17.5954L15.3907 18.8471C13.0265 16.3504 10.8543 13.6881 8.66884 11.0325L9.45692 11.3239C7.31122 11.5954 2.99997 12.2047 0.860895 12.5358L1.44368 11.5226L3.05957 15.5491L4.72182 19.5557L4.04632 18.9928C7.43705 19.5623 10.841 20.0458 14.1788 20.8736L13.1192 21.7544C13.1722 20.8405 13.2914 19.9265 13.4635 19.1318L13.4702 19.1385ZM14.5761 19.7742C14.702 20.7676 15.49 22.4034 14.1589 22.6484C12.3443 22.5093 10.5629 22.1054 8.7748 21.7875C7.08606 21.463 5.40394 21.112 3.72182 20.761C3.40394 20.708 3.14566 20.4828 3.04632 20.1981L1.57613 16.1186L0.0529476 12.0656C-0.119238 11.6285 0.172153 11.1252 0.635729 11.0524C2.7748 10.7213 7.06619 9.9994 9.19202 9.60867C9.50328 9.55569 9.79467 9.6749 9.9801 9.90006C12.2781 12.4961 14.5894 15.0921 16.702 17.8471C17.4304 19.1186 15.4371 19.3504 14.5761 19.7742Z'
              }
              fill={'#181716'}
              id={'Vector_8'}
            />
          </g>
          <g id={'Group_6'}>
            <path
              clipRule={'evenodd'}
              d={
                'M14.0264 26.2246V23.9199L3.88736 25.7941L0.748291 33.8868L9.32445 35.2113L16.0132 27.3703L14.0264 26.2246Z'
              }
              fill={'#ED6A70'}
              fillRule={'evenodd'}
              id={'Vector_9'}
            />
            <path
              d={
                'M13.4702 26.5424C13.3443 25.7278 13.2384 24.8272 13.1986 23.9199L14.1722 24.7278C10.8278 25.5292 7.43043 26.0788 4.04633 26.6417L4.69533 26.1053C3.86089 28.0987 2.23176 32.1384 1.4503 34.1517L0.867517 33.1384L5.16553 33.7543L9.47017 34.3172L8.64897 34.6219C10.8344 31.9662 12.9602 29.2643 15.3443 26.7874L15.5761 28.1451C14.8079 27.6417 14.0794 27.0855 13.4768 26.5424H13.4702ZM14.5761 25.9C15.5099 26.2974 17.298 26.4033 16.8609 27.7013C15.8344 29.2047 14.596 30.549 13.4238 31.9331C12.298 33.2311 11.1523 34.5159 10.0066 35.7941C9.80129 36.0457 9.48341 36.1517 9.1854 36.0987L4.91388 35.3305L0.635729 34.6153C0.172153 34.5424 -0.119238 34.0391 0.0529476 33.602C0.834405 31.5821 2.35096 27.5093 3.07944 25.4696C3.1854 25.1782 3.44368 24.9795 3.72844 24.9331C7.1258 24.2444 10.5298 23.5358 13.9735 23.0854C15.4437 23.0854 14.6424 24.9331 14.5761 25.8868V25.9Z'
              }
              fill={'#181716'}
              id={'Vector_10'}
            />
          </g>
          <g id={'Group_7'}>
            <path
              clipRule={'evenodd'}
              d={
                'M19.8809 29.6026L14.0266 26.2251V19.4569L19.8809 16.0728L25.7418 19.4569V26.2251L19.8809 29.6026Z'
              }
              fill={'#F8AC00'}
              fillRule={'evenodd'}
              id={'Vector_11'}
            />
            <path
              d={
                'M19.8809 30.2455C17.7219 29.4641 15.5232 28.1793 13.5166 26.974C13.2517 26.8085 13.106 26.5171 13.1126 26.2257C13.1921 24.2323 13.2583 21.4243 13.265 19.4575C13.265 19.1793 13.4173 18.9409 13.6424 18.8085L19.4703 15.378C19.7219 15.2323 20.0199 15.2389 20.2583 15.3647C20.2782 15.3581 26.1722 18.6694 26.1921 18.6628C26.4835 18.8217 26.6491 19.1197 26.6491 19.431C26.6623 19.4442 26.7087 26.2058 26.7219 26.219C26.7219 26.5767 26.5365 26.8945 26.2451 27.0667C24.2385 28.2389 22.0398 29.5171 19.8809 30.2455ZM19.8809 28.9674C21.6292 27.4707 23.3179 26.4575 25.2451 25.3714L24.755 26.2257L24.8279 19.4575L25.2848 20.2522L19.4769 16.7753H20.2848L14.3974 20.1065L14.7749 19.4575C14.7616 21.4111 14.8676 24.2389 14.9272 26.2257L14.4769 25.4442C16.4107 26.5104 18.1259 27.5171 19.8875 28.974L19.8809 28.9674Z'
              }
              fill={'#181716'}
              id={'Vector_12'}
            />
          </g>
          <g id={'Group_8'}>
            <path
              clipRule={'evenodd'}
              d={
                'M35.881 25.7956L25.7419 23.9214V26.226L23.7485 27.3717L30.4439 35.2128L39.0134 33.8883L35.881 25.7956Z'
              }
              fill={'#ED6A70'}
              fillRule={'evenodd'}
              id={'Vector_13'}
            />
            <path
              d={
                'M35.4702 26.285C32.0265 26.0333 28.9007 25.4572 25.5762 24.8148L26.649 23.9207L26.6027 26.2188V26.2519C26.596 26.5631 26.4239 26.828 26.1722 26.9671L24.159 28.0797L24.3709 26.8346C26.5364 29.5035 28.7748 32.1128 31.0397 34.6956L30.3179 34.4241C33.1656 33.9207 36.0133 33.3976 38.8676 32.9141L38.106 34.232C37.0596 31.6227 36.0795 29.0532 35.4768 26.2784L35.4702 26.285ZM36.2848 25.3048C37.8013 27.8744 38.8676 30.7618 39.9338 33.5565C40.1523 34.126 39.7682 34.775 39.159 34.8545C36.2914 35.2519 33.4239 35.6161 30.5563 36.0002C30.2782 36.0466 30 35.934 29.8344 35.7287C28.7285 34.4174 27.649 33.0797 26.5166 31.7817C25.3974 30.4837 24.2715 29.179 23.1192 27.9009C22.8212 27.5697 22.8477 27.0664 23.1788 26.7684C23.0596 26.7817 25.3113 25.4837 25.298 25.4704L24.8676 26.2188L24.8212 23.9207C24.8146 23.4241 25.2053 23.0201 25.702 23.0068C29.2119 23.583 32.9073 24.2916 36.2782 25.3048H36.2848Z'
              }
              fill={'#181716'}
              id={'Vector_14'}
            />
          </g>
        </g>
        <g id={'Group_9'}>
          <path
            clipRule={'evenodd'}
            d={
              'M17.2119 57.0727L7.90065 54.5363L4.47681 42.5562L16.4569 45.9866L19.8808 57.9667V72.0462'
            }
            fill={'#009996'}
            fillRule={'evenodd'}
            id={'Vector_15'}
          />
          <path
            d={
              'M17.0397 57.6886C13.8808 57.0661 10.7616 56.2846 7.65562 55.437C7.33112 55.3509 7.09271 55.0992 7.00662 54.7946C5.99337 51.3244 4.65562 46.3177 3.68874 42.7813C3.49006 42.1853 4.09933 41.5826 4.68874 41.7813C6.67549 42.3906 8.66887 42.9668 10.6622 43.5495C12.6556 44.1389 14.6556 44.682 16.6556 45.2449C16.9205 45.3177 17.1192 45.523 17.192 45.7747C17.7682 47.7747 18.3841 49.7615 18.9934 51.7482L20.8013 57.7085C20.8278 57.7879 20.8411 57.874 20.8411 57.9535C20.8411 57.98 20.8675 64.9932 20.8675 65.0197C20.8477 67.3641 20.7748 69.7151 20.5166 72.0595C20.4768 72.4105 20.1589 72.6687 19.8079 72.629C19.5033 72.5959 19.2715 72.3509 19.2384 72.0595C18.9735 69.7151 18.9073 67.3641 18.8874 65.0197L18.9139 57.98L18.9536 58.2449C17.9801 54.7019 16.6821 49.7019 15.702 46.2184L16.2384 46.7548C12.2583 45.5694 8.25827 44.437 4.25165 43.3575L5.25165 42.3575C6.33112 45.8873 7.7947 50.8144 8.7947 54.3045L8.14569 53.6621C11.2517 54.5032 14.3377 55.4105 17.3775 56.4767C18.106 56.735 17.8013 57.8608 17.0397 57.7085V57.6886Z'
            }
            fill={'#181716'}
            id={'Vector_16'}
          />
        </g>
        <g id={'Group_10'}>
          <path
            clipRule={'evenodd'}
            d={'M23.2187 57.6158L31.8677 54.5363L35.2981 42.5562L23.318 45.9866L20.8147 54.6687'}
            fill={'#009996'}
            fillRule={'evenodd'}
            id={'Vector_17'}
          />
          <path
            d={
              'M23.0067 57.0195C25.8411 55.8606 28.702 54.7678 31.5696 53.695L31.0067 54.291C31.9007 50.7943 33.4769 45.8407 34.5563 42.344L35.51 43.2976C31.6093 44.3506 27.4173 45.6619 23.5762 46.8738L24.212 46.238C23.6358 48.4235 23.0729 50.6155 22.3378 52.748C22.0795 53.4566 21.7815 54.1519 21.4305 54.8341C21.265 55.1519 20.8742 55.2778 20.5497 55.1122C20.3113 54.9864 20.1789 54.7347 20.1987 54.4765C20.265 53.7082 20.3842 52.9665 20.5431 52.2248C21.0597 50.0063 21.755 47.8407 22.4371 45.6685C22.5365 45.3705 22.7749 45.1586 23.0597 45.0857C25.0663 44.5559 27.0861 44.0592 29.0862 43.5096L32.0928 42.6884L35.0795 41.8076C35.6424 41.6221 36.2186 42.2049 36.0332 42.7612C35.0663 46.3308 33.8279 51.344 32.7087 54.8142C32.6226 55.0857 32.4107 55.2844 32.159 55.3705C30.7153 55.8738 29.2583 56.3374 27.8014 56.8208C26.3511 57.3043 24.8875 57.7612 23.4239 58.2049C23.0862 58.3109 22.7285 58.1188 22.6226 57.7811C22.5232 57.4632 22.6888 57.1255 22.9934 56.9996L23.0067 57.0195Z'
            }
            fill={'#181716'}
            id={'Vector_18'}
          />
        </g>
      </g>
      <defs>
        <clipPath id={'clip0_10731_6141'}>
          <rect fill={'white'} height={'72.6159'} width={'40'} />
        </clipPath>
      </defs>
    </svg>
  )
}
